import { render, staticRenderFns } from "./AuctionResultsPage.vue?vue&type=template&id=122e3eeb&"
import script from "./AuctionResultsPage.vue?vue&type=script&lang=js&"
export * from "./AuctionResultsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports